import {NgModule} from '@angular/core';
import {SetupRoutingModule} from './setup.routing.module';
import {RequiredCardStepComponent} from './required-card-step/required-card-step.component';
import {RequiredPersonalStepComponent} from './required-personal-step/required-personal-step.component';
import {ContactStepComponent} from './contact-step/contact-step.component';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../material.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {ProfileModule} from '../profile/profile.module';
import {PublicModule} from '../public/public.module';
import {QuickAddressCaptureComponent} from './quick-address-capture/quick-address-capture.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {CardsModule} from '../dashboard-module/cards/cards.module';
import { GenerateDigitalCardComponent } from './generate-digital-card/generate-digital-card.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ProfileModule,
        SharedComponentsModule,
        SetupRoutingModule,
        GoogleMapsModule,
        PublicModule,
        CardsModule,
        ReactiveFormsModule
    ],
    declarations: [
        RequiredPersonalStepComponent,
        ContactStepComponent,
        RequiredCardStepComponent,
        QuickAddressCaptureComponent,
        GenerateDigitalCardComponent,
    ],
    providers: [],
    exports: [
        RequiredPersonalStepComponent,
        ContactStepComponent,
        RequiredCardStepComponent,
        QuickAddressCaptureComponent,
    ]
})
export class SetupModule {}
